export const maxLength = {
    default: 50,
    mail: 150,
    phone: 15,
    otherSubjects: 1000
};

export const appointmentFormRegex = {
    namePattern: "^[a-zA-Z\u00C0-\u017E .'-]+$",
    otherSubjectPattern: '^[a-zA-Z0-9À-ÖØ-öø-ÿ,.\'\\s"?@$*=+():;/&!%€-]+$'
};

export const appointmentPattern = {
    dateOfBirth: 'yyyy-MM-dd'
};

export const datePattern = 'dd-MM-yyyy';
